import historyMiddleware from './history'

export default [historyMiddleware]
